import employeeApi from "./api/employeeApi";
import reportApi from "./api/reportApi";
import userApi from "./api/userApi";
import jmdoApi from "./api/jmdoApi";
// import viewDetailApi from "./api/viewDetailApi";

const apiService = { ...employeeApi, ...reportApi, ...userApi, ...jmdoApi };

export default apiService;
